function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Group_1",
  "data-name": "Group 1",
  transform: "translate(-152 -439)"
}, React.createElement("line", {
  id: "Line_1",
  "data-name": "Line 1",
  y1: 14.91,
  transform: "translate(184 463.788)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2.5
}), React.createElement("path", {
  id: "Path_1",
  "data-name": "Path 1",
  d: "M6,9.155,10.949,5",
  transform: "translate(173.051 458.302)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2.5
}), React.createElement("path", {
  id: "Path_2",
  "data-name": "Path 2",
  d: "M10.949,5,15.9,9.155",
  transform: "translate(173.051 458.302)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2.5
}), React.createElement("g", {
  id: "Ellipse_1",
  "data-name": "Ellipse 1",
  transform: "translate(152 439)",
  fill: "none",
  stroke: "rgba(0,0,0,0.2)",
  strokeWidth: 2.5
}, React.createElement("circle", {
  cx: 32,
  cy: 32,
  r: 32,
  stroke: "none"
}), React.createElement("circle", {
  id: "circle",
  cx: 32,
  cy: 32,
  r: 30.75,
  fill: "none"
})));

var SvgUpArrowCircle = function SvgUpArrowCircle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgUpArrowCircle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/up-arrow-circle.d6c4e78d.svg";
export { ForwardRef as ReactComponent };